import { Amplify } from 'aws-amplify'
import Brand from './brand'

export const configureAmplify = async () => {
  const host = window.location.host

  const subDomains = [
    { subDomain: 'qa2-diagnostics', domain: 'tr-dev.net' },
    { subDomain: 'qa-diagnostics', domain: 'tr-qa.net' },
    { subDomain: 'stage1-diagnostics', domain: 'tr-staging.net' },
    { subDomain: 'diagnostics', domain: 'tranehome.net' },
    { subDomain: 'localhost:8090', domain: 'tr-dev.net' }
  ]
  const subDomain = host.split('.')[0]
  const traneDomain = host.split('.')[1]
  const amplifyDomain = traneDomain === 'tranetechdev' ? 'tr-dev.net' : subDomains.find(s => s.subDomain === subDomain)?.domain
  const brandPath = Brand.isASAirHome() ? 'amstd' : 'trane'

  return fetch(`https://dwa-v2-api.${amplifyDomain}/amplify-config/${brandPath}/config.json`)
    .then(async (response) => await response.json())
    .then((config) => Amplify.configure(config))
}
